export default "__VITE_ASSET__4qFLYzZa__"